var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDrivenmarketing(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 47.405,
    height: 38.457,
    viewBox: "0 0 47.405 38.457",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Component_19_1",
    "data-name": "Component 19 \\u2013 1",
    transform: "translate(1 1.386)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_546",
    "data-name": "Path 546",
    d: "M879.783,792.768l-4.271,15.152a.92.92,0,0,0,.885,1.17h2.559a.92.92,0,0,0,.886-.674l4.163-15Z",
    transform: "translate(-869.985 -773.02)",
    fill: "none",
    stroke: "#358aca",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_547",
    "data-name": "Path 547",
    d: "M897.86,783.454v-9.095a1.149,1.149,0,0,0-1.63-1.043l-4.891,2.258a32.844,32.844,0,0,1-9.209,2.7l-4.766.666v9.02l4.546.619a32.858,32.858,0,0,1,9.259,2.691l5.064,2.324a1.149,1.149,0,0,0,1.627-1.044v-9.1",
    transform: "translate(-870.136 -771.455)",
    fill: "none",
    stroke: "#358aca",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_548",
    "data-name": "Path 548",
    d: "M873.721,788.194a4.213,4.213,0,1,1,0-8.426Z",
    transform: "translate(-869.507 -771.979)",
    fill: "none",
    stroke: "#358aca",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_549",
    "data-name": "Path 549",
    d: "M901.616,792.735",
    transform: "translate(-872.076 -773.017)",
    fill: "none",
    stroke: "#231f20",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_550",
    "data-name": "Path 550",
    d: "M906.5,780.1a4.691,4.691,0,0,1,0,7.823",
    transform: "translate(-872.467 -772.006)",
    fill: "none",
    stroke: "#b4cd7c",
    strokeLinecap: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_551",
    "data-name": "Path 551",
    d: "M909.135,775.685a9.555,9.555,0,0,1,0,15.939",
    transform: "translate(-872.678 -771.653)",
    fill: "none",
    stroke: "#b4cd7c",
    strokeLinecap: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_552",
    "data-name": "Path 552",
    d: "M911.85,771.3a14.391,14.391,0,0,1,0,24",
    transform: "translate(-872.895 -771.302)",
    fill: "none",
    stroke: "#b4cd7c",
    strokeLinecap: "round",
    strokeWidth: 2
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDrivenmarketing);
export default __webpack_public_path__ + "static/media/drivenmarketing.8e8848364b706cec64739e5db94e28ac.svg";
export { ForwardRef as ReactComponent };